import { render } from "./index.vue?vue&type=template&id=0f182b11"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render

export default script